import { useToggle } from "@kalodata/tools";
import { message } from "antd";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { IconLoading } from "@icons/index";
import { ReferenceVideoModal } from "./ReferenceVideoModal";
import { WelcomeVideoRemake } from "./WelcomeVideoRemake";
import { useWelcomeReferenceFromUrl } from "./useWelcomeReferenceFromUrl";
import { normalizeReferencePayload } from "./studio/types";

export function VideoRemakeWelcomePage() {
  const navigate = useNavigate();
  const [referenceModalOpen, setReferenceModalOpen] = useToggle();
  const { autoLoading } = useWelcomeReferenceFromUrl();

  if (autoLoading) {
    return (
      <div className="min-h-full bg-kds-bg-soft flex items-center justify-center text-kds-fg-soft">
        <IconLoading className="size-[28px] animate-spin" />
      </div>
    );
  }

  return (
    <>
      <WelcomeVideoRemake onGo2VideoRemake={() => setReferenceModalOpen(true)} />
      <ReferenceVideoModal
        open={referenceModalOpen}
        onClose={() => setReferenceModalOpen(false)}
        onPickVideoSuccess={(payload) => {
          const referenceVideo = normalizeReferencePayload(payload);
          if (!referenceVideo) {
            message.error(t("Failed to load reference video. Please try again."));
            return;
          }
          navigate("/video-remake/studio", { state: { referenceVideo } });
        }}
      />
    </>
  );
}
